<main class="success-page">
  <section class="success-shell">
    <div class="success-check" aria-hidden="true">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M20 6 9 17l-5-5"/></svg>
    </div>
    <h1>Booking confirmed</h1>
    <p class="success-intro">
      Your seats are reserved. We've sent your ticket
      @if (phone) { to <strong>{{ phone }}</strong> via SMS }
      @if (email) { and <strong>{{ email }}</strong> }.
    </p>

    <article class="e-ticket" id="booking-ticket">
      <header class="ticket-header">
        <div class="ticket-brand">
          @if (config?.self?.logo || config?.self?.logoLight) {
            <img [src]="config.self.logo || config.self.logoLight" [alt]="config.site.name">
          }
          <strong>E-Ticket</strong>
        </div>
        <div class="ticket-reference">
          <span>Booking ref</span>
          <strong>{{ bookingReference }}</strong>
        </div>
      </header>

      <div class="ticket-body">
        <div class="ticket-journeys">
          @for (journey of ticketJourneys; track journey.label) {
            <section class="ticket-journey-block">
              <div class="ticket-journey-heading">
                <strong>{{ journey.label }}</strong>
                <span>{{ journey.travelDate }}</span>
              </div>
              <div class="ticket-journey">
                <div>
                  <strong>{{ journey.departureTime }}</strong>
                  <span>{{ journey.from }}</span>
                </div>
                <i></i>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>
                <i></i>
                <div class="is-arrival">
                  <strong>{{ journey.arrivalTime }}</strong>
                  <span>{{ journey.to }}</span>
                </div>
              </div>

              <dl class="ticket-details">
                <div><dt>Operator</dt><dd>{{ journey.operator }}</dd></div>
                <div><dt>Seats</dt><dd>{{ journey.seats }}</dd></div>
                <div>
                  <dt>Passengers</dt>
                  <dd>{{ journey.passengerCount }} {{ journey.passengerCount === 1 ? 'traveller' : 'travellers' }}</dd>
                </div>
                <div><dt>Pickup</dt><dd>{{ journey.pickup }}</dd></div>
                <div><dt>Drop-off</dt><dd>{{ journey.dropoff }}</dd></div>
              </dl>
            </section>
          }
        </div>

        <section class="ticket-passengers" aria-labelledby="ticket-passengers-title">
          <h2 id="ticket-passengers-title">Passenger information</h2>
          <div class="ticket-passenger-list">
            @for (passenger of passengers; track $index; let passengerIndex = $index) {
              <article class="ticket-passenger">
                <span>{{ passengerIndex + 1 }}</span>
                <div>
                  <strong>{{ passenger.name }}</strong>
                  @if (passenger.phone) { <small>{{ passenger.phone }}</small> }
                </div>
                <p>
                  <small>Seat</small>
                  <strong>{{ passenger.seat }}@if (passenger.seatClass) { · {{ passenger.seatClass }} }</strong>
                </p>
              </article>
            }
          </div>
        </section>

        <div class="ticket-footer">
          <div>
            <span>Amount paid · {{ paymentMethod }}</span>
            <strong>{{ currencyLabel }} {{ amountPaid | number }}</strong>
          </div>
          <qrcode
            class="ticket-qr"
            [qrdata]="bookingReference"
            [width]="66"
            [margin]="0"
            [errorCorrectionLevel]="'M'">
          </qrcode>
        </div>
      </div>
    </article>

    <div class="success-actions">
      <button type="button" class="download-ticket" (click)="downloadTicket()">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M12 3v12M7 10l5 5 5-5M5 21h14"/></svg>
        Download ticket
      </button>
      <button type="button" class="view-booking" (click)="viewBooking()">View booking</button>
      <button type="button" class="return-home" (click)="returnHome()">Return home</button>
    </div>
  </section>
</main>
